import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';

const useStyles = makeStyles((theme) => ({
    root: {
        width: '50px',
        display: 'flex',
        '& > * + *': {
            marginLeft: theme.spacing(2),
        },
        marginTop: '55px',
        marginRight: 'auto',
        marginLeft: 'auto',
        alignSelf: 'center',
        
    },
    circle: {
        color: '#00BFA5'
    }
}));

const LoadingCircle = () => {
    const classes = useStyles();

    return (
        <div className={classes.root} id='loading-element'>
            <CircularProgress className={classes.circle} />
        </div>
    );
};

export default LoadingCircle;